import {Component, ViewChild, Input, Output, EventEmitter, ElementRef, Renderer} from '@angular/core';
import { UploaderOptions, UploadInput } from 'ngx-uploader';
import * as _ from 'lodash';

@Component({
  selector: 'ba-picture-uploader',
  styleUrls: ['./baPictureUploader.scss'],
  templateUrl: './baPictureUploader.html',
})
export class BaPictureUploader {

  defaultPicture:string =  'assets/img/theme/no-photo.png';
  @Input() picture:string = '';

  @Input() options:{ concurrency: 1, maxUploads: 3,allowedContentTypes:[], maxFileSize: 1000000 };
  @Input() canDelete:boolean = true;

  @Output() onUpload = new EventEmitter<any>();
  @Output() onUploadCompleted = new EventEmitter<any>();

  @Output() onRemovePicture = new EventEmitter<any>();

  @ViewChild('fileUpload',{static:true}) public _fileUpload:ElementRef;

  public uploadInProgress:boolean;
  uploadInput: EventEmitter<UploadInput>;

  constructor(private renderer: Renderer) {
  }

  beforeUpload(uploadingFile): void {
    let files = this._fileUpload.nativeElement.files;

    if (files.length) {
      const file = files[0];
      let extension =  file.name.split('.')[1];
      if (!_.includes(this.options.allowedContentTypes, extension)) {

        uploadingFile.setAbort();
        return;
      }

      this._changePicture(file);

      if (!this._canUploadOnServer()) {
        uploadingFile.setAbort();
      } else {
        this.uploadInProgress = true;
      }
    }
  }

  bringFileSelector():boolean {
    this.renderer.invokeElementMethod(this._fileUpload.nativeElement, 'click');
    return false;
  }

  removePicture():boolean {
    this.picture = '';
    this.onRemovePicture.emit('');
    return false;
  }

  _changePicture(file:File):void {
    const reader = new FileReader();
    reader.addEventListener('load', (event:Event) => {
      this.picture = (<any> event.target).result;
    }, false);
    reader.readAsDataURL(file);
  }

  _onUpload(data):void {
    if (data['done'] || data['abort'] || data['error']) {
      this._onUploadCompleted(data);
    } else {
      this.onUpload.emit(data);
    }
  }

  _onUploadCompleted(data):void {
    this.uploadInProgress = false;
    this.onUploadCompleted.emit(data);
  }

  _canUploadOnServer():boolean {
    return !!this.options['url'];
  }
}
